import { useEffect } from "react";
import Lenis from "lenis";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import LiveSpotlight from "./components/LiveSpotlight";
import LinkChapter from "./components/LinkChapter";
import DiscordSection from "./components/DiscordSection";
import Footer from "./components/Footer";
import { CHAPTERS } from "./data/links";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const noLenis = new URLSearchParams(window.location.search).has("nolenis");
    if (prefersReduced || noLenis) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App relative bg-[#050505] text-[#f8f8f8]">
      <div className="noise-overlay" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/grunge.jpg)` }} />
      <main>
        <LiveSpotlight />
        <Hero />
        <Featured />
        {CHAPTERS.map((c) => (
          <LinkChapter key={c.id} chapter={c} />
        ))}
        <DiscordSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
